export const validatePhoneNumber = (number) => {
  // const phoneRegex = /^\+?[1-9][0-9]{7,16}$/;
  const phoneRegex = /^[1-9][0-9]{7,16}$/;


  return phoneRegex.test(number);
};
